<template>
    <div class="advertising-container">
        <div class="advertising-box">
            <div class="qr-code">
                <img src="https://cdn1.p2ipo.com/vx.png" alt="">
            </div>
            <div class="info-box">
                <div class="content">
                    <div class="txt1">
                        <span class="sp1">关注公众号第一时间获取新鲜资讯和深度商业分析，请在微信公众号搜索</span>
                        <span class="sp2">“交大众创”</span>
                    </div>
                    <div class="txt2">
                        <span class="sp1">或者</span>
                        <span class="sp2">“钉钉租房”</span>
                    </div>
                    <div class="txt3">或用手机扫描左方二维码，即可获得每日精华内容推送</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'advertisingComponentP',
    data() {
        return {}
    }
}
</script>
<style lang="scss" scoped>
@import './AdvertisingComponentP.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/advertising/AdvertisingComponentP.vue